// Lucide icons (react-icons/lu) re-typed as FC so they work as JSX with the
// project's @types/react version (react-icons 5 returns ReactNode).
import { FC } from "react";
import { IconBaseProps, IconType } from "react-icons";
import * as Lu from "react-icons/lu";
import { FaDiscord, FaFacebookF, FaLinux, FaWindows, FaYoutube } from "react-icons/fa";

type Icon = FC<IconBaseProps>;
const fix = (icon: IconType) => icon as unknown as Icon;

export const IcCheck = fix(Lu.LuCheck);
export const IcChevronLeft = fix(Lu.LuChevronLeft);
export const IcChevronRight = fix(Lu.LuChevronRight);
export const IcCircleHelp = fix(Lu.LuCircleHelp);
export const IcClock = fix(Lu.LuClock);
export const IcCloud = fix(Lu.LuCloud);
export const IcCopy = fix(Lu.LuCopy);
export const IcCpu = fix(Lu.LuCpu);
export const IcDownload = fix(Lu.LuDownload);
export const IcEllipsis = fix(Lu.LuEllipsis);
export const IcFileText = fix(Lu.LuFileText);
export const IcGamepad = fix(Lu.LuGamepad2);
export const IcGlobe = fix(Lu.LuGlobe);
export const IcHouse = fix(Lu.LuHouse);
export const IcIdCard = fix(Lu.LuIdCard);
export const IcKeyRound = fix(Lu.LuKeyRound);
export const IcLogOut = fix(Lu.LuLogOut);
export const IcMenu = fix(Lu.LuMenu);
export const IcMonitor = fix(Lu.LuMonitor);
export const IcMonitorSmartphone = fix(Lu.LuMonitorSmartphone);
export const IcMoon = fix(Lu.LuMoon);
export const IcReceipt = fix(Lu.LuReceipt);
export const IcScrollText = fix(Lu.LuScrollText);
export const IcSearch = fix(Lu.LuSearch);
export const IcServer = fix(Lu.LuServer);
export const IcSun = fix(Lu.LuSun);
export const IcTrash = fix(Lu.LuTrash2);
export const IcUser = fix(Lu.LuUser);
export const IcUsers = fix(Lu.LuUsers);
export const IcWallet = fix(Lu.LuWallet);
export const IcPower = fix(Lu.LuPower);
export const IcX = fix(Lu.LuX);
export const IcFilter = fix(Lu.LuSlidersHorizontal);
export const IcMinus = fix(Lu.LuMinus);
export const IcPlus = fix(Lu.LuPlus);
export const IcRefresh = fix(Lu.LuRefreshCw);
export const IcEye = fix(Lu.LuEye);
export const IcEyeOff = fix(Lu.LuEyeOff);
export const IcChevronDown = fix(Lu.LuChevronDown);
export const IcAlert = fix(Lu.LuTriangleAlert);
export const IcSettings = fix(Lu.LuSettings);
export const IcSmartphone = fix(Lu.LuSmartphone);
export const IcLaptop = fix(Lu.LuLaptop);
export const IcLink = fix(Lu.LuLink);
export const IcArrowLeftRight = fix(Lu.LuArrowLeftRight);
export const IcRotateCw = fix(Lu.LuRotateCw);
export const IcBackup = fix(Lu.LuHardDriveDownload);
export const IcHistory = fix(Lu.LuHistory);
export const IcWindows = fix(FaWindows);
export const IcLinux = fix(FaLinux);
export const IcCircuitBoard = fix(Lu.LuCircuitBoard);
export const IcMemoryStick = fix(Lu.LuMemoryStick);
export const IcHardDrive = fix(Lu.LuHardDrive);
export const IcZap = fix(Lu.LuZap);
export const IcPackage = fix(Lu.LuPackage);
export const IcShield = fix(Lu.LuShield);
export const IcCart = fix(Lu.LuShoppingCart);
export const IcMapPin = fix(Lu.LuMapPin);
export const IcGrid = fix(Lu.LuLayoutGrid);
export const IcBookOpen = fix(Lu.LuBookOpen);
export const IcFan = fix(Lu.LuFan);
export const IcCircleCheck = fix(Lu.LuCircleCheck);
export const IcBell = fix(Lu.LuBell);
export const IcGift = fix(Lu.LuGift);
export const IcExternalLink = fix(Lu.LuExternalLink);
export const IcBanknote = fix(Lu.LuBanknote);
export const IcShare = fix(Lu.LuShare2);
export const IcUserPlus = fix(Lu.LuUserPlus);
export const IcQr = fix(Lu.LuQrCode);
export const IcInfo = fix(Lu.LuInfo);
export const IcArrowLeft = fix(Lu.LuArrowLeft);
export const IcArrowIn = fix(Lu.LuArrowDownLeft);
export const IcArrowOut = fix(Lu.LuArrowUpRight);
export const IcBank = fix(Lu.LuLandmark);
export const IcRocket = fix(Lu.LuRocket);
export const IcUsb = fix(Lu.LuUsb);
export const IcMail = fix(Lu.LuMail);
export const IcActivity = fix(Lu.LuActivity);
export const IcPhone = fix(Lu.LuPhone);
export const IcFacebook = fix(FaFacebookF);
export const IcYoutube = fix(FaYoutube);
export const IcDiscord = fix(FaDiscord);
export const IcFolder = fix(Lu.LuFolder);
